import React, { useCallback, useState } from 'react';
import { Tabs, Pagination, Space, Input, Skeleton } from 'antd';
import { enmTabPosition } from '../../models/enums/TabPosition';
import { mdlAgencyListResponse } from '../../models/service-models/agency/AgencyListResponse';
import { mdlAgencyListGroup } from '../../models/AgencyListGroup';
import AgencyDetail from './AgencyDetail';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import fallbackImage from "../../assets/img/agency-no-logo.jpg";
import { getAgencyLogoURL } from '../../utils/S3Helper';


export type AgencyListProps = {
    agencies?: mdlAgencyListResponse;
    hotelId?: string;
    refreshList?: Function
};

const ITEMS_PER_PAGE = 16;

const AgencyList = ({ agencies, hotelId, refreshList }: AgencyListProps) => {
    const [selectedAgency, setSelectedAgency] = useState<mdlAgencyListGroup | null>(null);
    const [currentPageAll, setCurrentPageAll] = useState(1);
    const [currentPageConnected, setCurrentPageConnected] = useState(1);
    const [search, setSearch] = useState<string>("");
    const { t } = useTranslation();

    const handleCardClick = (agency: mdlAgencyListGroup) => {

        setSelectedAgency(agency);
    };

    const handleBackClick = () => {
        setSelectedAgency(null);
        refreshList?.()
    };    

    const renderAgencyGrid = (agencyList: Array<mdlAgencyListGroup> = [], currentPage: number, onPageChange: (page: number) => void) => {
        const startIdx = (currentPage - 1) * ITEMS_PER_PAGE;
        const paginatedData = agencyList.slice(startIdx, startIdx + ITEMS_PER_PAGE);

        return (
            <>
                <div className="container">
                    <div className="row">
                        {paginatedData.sort((a, b) => a.name!.localeCompare(b.name!)) // Alfabetik sıralama
                            .map((agency) => (
                                <div key={agency.id} className="col-md-3 mb-4">
                                    <div className="card h-100 text-center border" role="button" onClick={() => handleCardClick(agency)}>
                                        <img
                                            src={getAgencyLogoURL(agency.image)}
                                            alt={agency.name}
                                            className="card-img-top border"
                                            style={{ height: 262, objectFit: 'contain', border: '1px solid' }}
                                            onError={(e) => {
                                                e.currentTarget.src = fallbackImage;
                                            }}
                                        />
                                        <div className="card-body">
                                            <h5 className="card-title">{agency.name}</h5>
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
                {agencyList.length > ITEMS_PER_PAGE && (
                    <div className="pagination-container text-end mt-3 d-flex justify-end">
                        <Pagination
                            current={currentPage}
                            pageSize={ITEMS_PER_PAGE}
                            total={agencyList.length}
                            onChange={onPageChange}
                            showSizeChanger={false}
                        />
                    </div>
                )}
            </>
        );
    };
    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
        debouncedSearch(e.target.value);
    };

    const debouncedSearch = useCallback(
        _.debounce((value: string) => refreshList?.(value), 500),
        []
    );

    return (
        <div className="mt-2">

            {hotelId && <>
                <hr />
                {selectedAgency ? (
                    <AgencyDetail handleBackClick={handleBackClick} id={selectedAgency.id!} hotelId={hotelId!} />
                ) : (
                    <>
                        <Space align="center" style={{ justifyContent: "flex-end", display: "flex" }}>
                            <Input.Search
                                placeholder={t("agencies.name")}
                                onChange={handleSearchChange}
                            />
                        </Space>
                        <hr />
                        {
                            agencies ? <Tabs
                                tabPosition={enmTabPosition.LEFT}
                                items={[
                                    {
                                        label: (
                                            <div className="d-flex justify-between">
                                                <span>{t("agencies.allAgencies")}</span>
                                                <span
                                                    className="badge ms-2"
                                                    style={{
                                                        fontSize: '12px',
                                                        padding: '2px 8px',
                                                        borderRadius: '12px',
                                                        backgroundColor: '#b4c4cd'
                                                    }}
                                                >
                                                    {agencies?.allAgencies.length}
                                                </span>
                                            </div>
                                        ),
                                        key: '1',
                                        children: renderAgencyGrid(
                                            agencies?.allAgencies || [],
                                            currentPageAll,
                                            setCurrentPageAll
                                        ),
                                    },
                                    {
                                        label: (
                                            <div className="d-flex justify-between">
                                                <span>{t("agencies.connectedAgencies")}</span>
                                                <span
                                                    className="badge ms-2"
                                                    style={{
                                                        fontSize: '12px',
                                                        padding: '2px 8px',
                                                        borderRadius: '12px',
                                                        backgroundColor: '#b4c4cd'
                                                    }}
                                                >
                                                    {agencies?.connectedAgencies.length}
                                                </span>
                                            </div>
                                        ),
                                        key: '2',
                                        children: renderAgencyGrid(
                                            agencies?.connectedAgencies || [],
                                            currentPageConnected,
                                            setCurrentPageConnected
                                        ),
                                    },
                                ]}
                            /> : <>
                                <Skeleton active />
                            </>
                        }

                    </>
                )}

            </>}

        </div>
    );
};

export default AgencyList;
